import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VestaModule } from 'vesta';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    VestaModule.forRoot({ isAuthentication: false })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
